export default __webpack_public_path__ + "static/logo-47880447cb2f68b21578d8f62f5bd515.png";